import { useNavigate } from 'react-router-dom';

import Box from 'components/shared/Box/Box';
import Button from 'components/shared/Buttons/Button';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

const Messages = ({ title, latestMessages }) => {
  const navigate = useNavigate();
  return (
    <Box className="flex flex-col gap-4">
      <span className="text-xl font-500 text-neutral-900">{title}</span>
      {latestMessages.number_unread > 0 ? (
        <div className="flex flex-col gap-2">
          <span>{`You have ${latestMessages.number_unread} new messages`}</span>
        </div>
      ) : (
        <p className="text-sm text-neutral-700">You don't have any new messages!</p>
      )}
      <Button
        className="mt-auto"
        text="See all messages"
        onClick={() => navigate('/myportal/inbox')}
      />
    </Box>
  );
};

export default withErrorBoundary(Messages);
